import React from 'react';
import EmptyPage from './EmptyPage';
import NoSurveyDataImage from '../assets/images/emptyPages/NoSurveyData.svg';
import { getTranslation } from '../locales';

interface SurveyErrorPageProps {
  locale?: string;
}

const SurveyErrorPage: React.FC<SurveyErrorPageProps> = ({ locale = "en" }) => {
  const t = getTranslation(locale);
  
  return (
    <EmptyPage
      message={t.invalidSurveyLink}
      subMessage={t.surveyLoadError}
      image={NoSurveyDataImage}
    />
  );
};

export default SurveyErrorPage;

